export default __webpack_public_path__ + "static/media/leave-calendar-blue.787c913c.svg";